







































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import ListMixin from "@/components/mixin/list-mixin";
import { mixins } from "vue-class-component";
import columns from "./customer-type-columns";
class PageCustomerTypeRequest extends PageRequest {
  keyword: string;
  pricingTermCode: string;
}

@Component
export default class CustomerType extends mixins(ListMixin, AbpBase) {
  namespace = "customerType";
  pagerequest: PageCustomerTypeRequest = new PageCustomerTypeRequest();
  spinShow: boolean = false;
  pricingTerms = [];
  get store() {
    return this.$store.state.customerType;
  }
  isClient() {
    return this.$store.state.session.client != null;
  }

  async getPricingTerms() {
    await this.$store
      .dispatch({
        type: "productPricing/getPricingTerms",
        data: { hasAllItem: true },
      })
      .then((result) => {
        this.pricingTerms = result;
        this.pagerequest.pricingTermCode =
          this.pricingTerms.length === 0 ? "" : this.pricingTerms[0].id;
      });
  }
  viewCustomerType(code: string) {
    this.$root.$router.push({
      name: "customertype/:code",
      params: { code: code },
    });
  }
  createCustomerType() {
    this.$root.$router.push({ path: "create/customertype" });
  }
  updateCustomerType(code: string) {
    this.$root.$router.push({
      name: "update/customertype/:code",
      params: { code: code },
    });
  }
  get list() {
    var re = this.store.list;
    var startIndex = (this.currentPage - 1) * this.pageSize;
    var index = 0;
    re.forEach(function(item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }
  renderColumn() {
    return columns;
  }
  columns = [
    {
      title: Util.L("Order"),
      key: "orderNo",
      width: 80,
    },
    ...this.renderColumn(),
    {
      title: Util.L("Action"),
      width: 100,
      fixed: "right",
      slot: "action",
      align: "center",
    },
  ];
  async created() {
    this.spinShow = true;
    try {
      await this.getPricingTerms();
      this.spinShow = false;
    } catch (error) {
      this.spinShow = false;
    }
  }
}
